import React from 'react';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
	ChartOptions,
} from 'chart.js';
import {Bar} from 'react-chartjs-2';
import {useTranslation} from 'react-i18next';
import {monthNow} from '../../assets/utils/dateUtils';
import {useGetMonthNewbieQuery} from '../../redux/myDynamicApi';
import Loader from '../../assets/Animations/PreLoaderComponent/Loader';

ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
);

type Props = {};

const QualificationChartTeamBeginer: React.FC<Props> = () => {
	const {t} = useTranslation();
	const {data: stats, isLoading} = useGetMonthNewbieQuery(monthNow());
	const labels = stats?.stats?.map((day_stat) =>
		new Date(day_stat.month).toLocaleString('uk-UA', {month: 'long'}),
	);

	const options: ChartOptions<'bar'> = {
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			datalabels: {
				display: false,
			},
			legend: {display: true},
		},
		elements: {
			bar: {
				borderRadius: 10,
			},
		},
		scales: {
			x: {
				title: {
					display: true,
					text: t('Місяці'),
				},
				grid: {
					display: false,
				},
			},
			y: {
				title: {
					display: true,
					text: t('Кількість'),
				},
				beginAtZero: true,
				grid: {
					display: false,
				},
			},
		},
	};

	const data = {
		labels,
		datasets: [
			{
				label: t('видалено'),
				data: stats?.stats?.map((s) => s.count_deleted),
				backgroundColor: '#738772',
				borderWidth: 0,
			},
			{
				label: t('зареєстровано'),
				data: stats?.stats?.map((s) => s.count_registered),
				backgroundColor: '#adc896',
				borderWidth: 0,
			},
		],
	};

	return (
		<div style={{height: 280}}>
			{isLoading ? <Loader /> : <Bar options={options} data={data} />}
		</div>
	);
};

export default QualificationChartTeamBeginer;
